import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DateTimeConvertService } from 'src/app/services/CommonService/DateTimeConvert.service';
import { AppComponent } from 'src/app/app.component';
import { tConsultHeadModelWithPatientInfo } from 'src/app/models/tConsultHeadModel';
import { LoggerService } from 'src/app/services/Non-Master/logger.service';
import { Input, Component, OnInit } from '@angular/core';
import { BillPay_PaymentMethod_Class } from 'src/app/models/tPaymentModel';
import { SelectionModel } from '@angular/cdk/collections';
import { DatePipe } from '@angular/common';
import { AppCurrencyPipeModule } from 'src/app/services/CommonService/custom.currency.pipe';
import { NavigationComponent } from 'src/app/pages/navigation/navigation.component';
import { tShoppingCartModelWithItemCateInfo } from 'src/app/models/tShoppingCartModel';
import { BillPay_ItemType } from 'src/app/models/tBillPayModel';
import { AppSettings } from 'src/app/shared/AppSettings';


@Component({
  selector: 'app-invoice-preview',
  templateUrl: './invoice-preview.component.html',
  styleUrls: ['./invoice-preview.component.css']
})
export class InvoicePreviewComponent implements OnInit {


  urlStartingPath = AppSettings.shopAdapter.imagePath;
  picFullPath = this.urlStartingPath+"/assets/img/print/doc_logo.png";

  constructor(
    public activeModal: NgbActiveModal,
    private dateTimeConvertService: DateTimeConvertService,
    private log: LoggerService,
    private datepipe: DatePipe,

  ) { }

 // picFullPath = './assets/img/print/doc_logo.png';
  // picFullPath = window.location.origin + '/assets/img/print/doc_logo.png';
  TAG = 'BillpayReceiptCertComponent';

  isHiddenShop1Info = true;
  isHiddenShop2Info = true;


  @Input() selectedtConsultHeadModelWithPatientInfo: tConsultHeadModelWithPatientInfo;
  @Input() dataList_Item: tShoppingCartModelWithItemCateInfo[];
  @Input() dataList_Payment: tShoppingCartModelWithItemCateInfo[];

  @Input() isCheckBoxSelectedAll: boolean;
  @Input() selectedModel: SelectionModel<tShoppingCartModelWithItemCateInfo>;

  // @Input() billingNumber: string;

  public display_patientName: string;
  public display_date: Date;
  public display_diagonsis: string;
  // tslint:disable-next-line:max-line-length
  public display_line = '---------------------------------------------------------------------------------------------------------------------------------';
  public display_itemNameList: string;
  public display_itemPriceList: string;
  public display_itemSubtotal: string;

  public display_paymentList: string;
  public display_paymentPriceList: string;
  public display_totalPaidAmount: string;

  public extraRemark: string;

  printReceipt_paymentClass: Array<BillPay_PaymentMethod_Class> = [];

  ngOnInit() {
    // this.log.i(this.TAG, 'isCheckBoxSelectedAll = ' + this.isCheckBoxSelectedAll);

    if (this.isCheckBoxSelectedAll === true) {
      this.SetupReceiptString();
    } else {

  //    this.log.i(this.TAG, ' selectedModel = ' + JSON.stringify(this.selectedModel.selected));

      this.SetupPrintNonFullReciptString();
    }

    this.setDefaultLanguageString(AppComponent.usingLanguage);


    if (NavigationComponent.selectedShopID.toString() === '2') {
      this.isHiddenShop1Info = true;
      this.isHiddenShop2Info = false;
    } else {
      this.isHiddenShop1Info = false;
      this.isHiddenShop2Info = true;
    }


  }

  SetupReceiptString() {
    this.log.i(this.TAG, 'do SetupReceiptString  ');


    this.display_patientName = this.selectedtConsultHeadModelWithPatientInfo.patientChiName
    + ' ' + this.selectedtConsultHeadModelWithPatientInfo.patientSurname
    + ' ' + this.selectedtConsultHeadModelWithPatientInfo.patientFirstName;
    // this.display_patientName = this.selectedtConsultHeadModelWithPatientInfo.patientChiName;

    this.display_date = this.selectedtConsultHeadModelWithPatientInfo.clthArrivalDateTime;
    this.display_diagonsis = this.selectedtConsultHeadModelWithPatientInfo.clthDiagonsis;

    this.display_itemNameList = '';
    this.display_itemPriceList = '';
    this.display_itemSubtotal = '';

    let itemSubTotal = 0;
    let isChangeAccount = false;


    for (let i = 0; i < this.dataList_Item.length; i++) {
      // if bpPrintName not, get auto
      if (this.dataList_Item[i].bpPrintName === '' || this.dataList_Item[i].bpPrintName == null
        || this.dataList_Item[i].bpPrintName === undefined) {
        this.display_itemNameList += this.dataList_Item[i].bpItemDesc;

      } else {
        this.display_itemNameList += this.dataList_Item[i].bpPrintName;
      }

      // Add Qty Display
      // if (this.dataList_Item[i].itemCateIsService !== 'Y') {
      //   this.display_itemNameList += ' x ' + this.dataList_Item[i].bpQty;
      // }

      if (this.dataList_Item[i].itemCateID !== '10'
        && this.dataList_Item[i].itemCateID !== '20'
        && this.dataList_Item[i].itemCateID !== '50'
        && this.dataList_Item[i].itemCateID !== 'd97'
        && this.dataList_Item[i].itemCateID !== 'd98'
        && this.dataList_Item[i].itemCateID !== 'd99') {
        this.display_itemNameList += ' x ' + this.dataList_Item[i].bpQty;
      }



      // packdis
      if (this.dataList_Item[i].bpPackDis != null && this.dataList_Item[i].bpPackDis !== undefined) {

        const bpPackDis = parseFloat(this.dataList_Item[i].bpPackDis);
        //   this.log.i(this.TAG,"bpPackDis= "+this.dataList_Item[i].bpPackDis +" , this.dataList_Item[i].bpArAmount *bpPackDis = "+this.dataList_Item[i].bpArAmount *bpPackDis);

        this.display_itemPriceList += '$' + (this.dataList_Item[i].bpArAmount * bpPackDis).toFixed(1);
        itemSubTotal += (this.dataList_Item[i].bpArAmount * bpPackDis);

      } else {
        this.display_itemPriceList += '$' + (this.dataList_Item[i].bpArAmount).toFixed(1);
        itemSubTotal += (this.dataList_Item[i].bpArAmount);

      }

      // add next line
      if (i + 1 < this.dataList_Item.length) {
        this.display_itemNameList += '\n';
        this.display_itemPriceList += '\n';

        // check is it changeAccount
        if (this.dataList_Item[i].bpChangeID != null && this.dataList_Item[i].bpChangeID !== undefined) {
          this.log.i(this.TAG, 'isChangeAccount true');
          isChangeAccount = true;
        }
      }



    }
    this.display_itemSubtotal = '$' + itemSubTotal.toFixed(1);


    // // -----------------payment display
    // this.display_paymentList = '';
    // this.display_totalPaidAmount = '';

    // // const printReceipt_paymentClass: Array<BillPay_PaymentMethod_Class> = [];
    // this.printReceipt_paymentClass =  [];

    // // this.log.i(this.TAG,"dataList_Payment length = "+this.dataList_Payment.length);
    // for (let i = 0; i < this.dataList_Payment.length; i++) {

    //   // group payment Method
    //   if (this.printReceipt_paymentClass.length === 0) {


    //     if (this.dataList_Payment[i].bpPaymentMethodID === 'Package' && this.dataList_Payment[i].bpPackDis != null && this.dataList_Payment[i].bpPackDis !== undefined) {

    //       // paymentMethod With package
    //       this.printReceipt_paymentClass.push(new BillPay_PaymentMethod_Class(
    //         this.dataList_Payment[i].bpPaymentMethodID,
    //         this.dataList_Payment[i].bpPaymentMethodName,
    //         (this.dataList_Payment[i].bpArAmount * parseFloat(this.dataList_Payment[i].bpPackDis)),
    //         this.dataList_Payment[i].bpItemType,
    //         this.dataList_Payment[i].bpPackDesc,
    //         this.dataList_Payment[i].bpPackDis,
    //         this.dataList_Payment[i].bpPackPatientID,
    //         this.dataList_Payment[i].specialPaymentType
    //       ));

    //     } else {

    //       // paymentMethod Without package

    //       //
    //       if (this.dataList_Payment[i].specialPaymentType === 2) {

    //         this.printReceipt_paymentClass.push(new BillPay_PaymentMethod_Class(
    //           this.dataList_Payment[i].bpPaymentMethodID,
    //           this.dataList_Payment[i].bpPaymentMethodName + '\n' + this.dataList_Payment[i].ehVoucher,
    //           this.dataList_Payment[i].bpArAmount,
    //           this.dataList_Payment[i].bpItemType,
    //           this.dataList_Payment[i].bpPackDesc,
    //           this.dataList_Payment[i].bpPackDis,
    //           this.dataList_Payment[i].bpPackPatientID,
    //           this.dataList_Payment[i].specialPaymentType

    //         ));

    //       } else {
    //         this.printReceipt_paymentClass.push(new BillPay_PaymentMethod_Class(
    //           this.dataList_Payment[i].bpPaymentMethodID,
    //           this.dataList_Payment[i].bpPaymentMethodName,
    //           this.dataList_Payment[i].bpArAmount,
    //           this.dataList_Payment[i].bpItemType,
    //           this.dataList_Payment[i].bpPackDesc,
    //           this.dataList_Payment[i].bpPackDis,
    //           this.dataList_Payment[i].bpPackPatientID,
    //           this.dataList_Payment[i].specialPaymentType

    //         ));
    //       }


    //     }

    //   } else {

    //     for (let p = 0; p < this.printReceipt_paymentClass.length; p++) {
    //       // if same payment Method

    //       //  this.log.i(this.TAG,"p = "+p+" , printReceipt_paymentClass[p].paymentID = "+printReceipt_paymentClass[p].paymentID+" , this.dataList_Payment[i].bpPaymentMethodID = "+this.dataList_Payment[i].bpPaymentMethodID);
    //       if (this.printReceipt_paymentClass[p].paymentID === this.dataList_Payment[i].bpPaymentMethodID) {

    //         if (this.dataList_Payment[i].bpPaymentMethodID === 'Package' && this.dataList_Payment[i].bpPackDis != null && this.dataList_Payment[i].bpPackDis !== undefined) {
    //           this.printReceipt_paymentClass[p].paymentAmount += (this.dataList_Payment[i].bpArAmount * parseFloat(this.dataList_Payment[i].bpPackDis));

    //         } else {
    //           this.printReceipt_paymentClass[p].paymentAmount += this.dataList_Payment[i].bpArAmount;

    //         }


    //         //  this.log.i(this.TAG,"same payment ID :"+this.dataList_Payment[i].bpPaymentMethodID+" ,new paymentAmount = "+printReceipt_paymentClass[p].paymentAmount);
    //         break;
    //       } else if ((p + 1 < this.printReceipt_paymentClass.length) === false) {
    //         // if not same payment method

    //         if (this.dataList_Payment[i].specialPaymentType === 2) {
    //           this.log.d(this.TAG, 'this.dataList_Payment[i].ehVoucher = ' + this.dataList_Payment[i].ehVoucher);
    //           this.printReceipt_paymentClass.push(new BillPay_PaymentMethod_Class(
    //             this.dataList_Payment[i].bpPaymentMethodID,
    //             this.dataList_Payment[i].bpPaymentMethodName + '\n' + this.dataList_Payment[i].ehVoucher,
    //             this.dataList_Payment[i].bpArAmount,
    //             this.dataList_Payment[i].bpItemType,
    //             this.dataList_Payment[i].bpPackDesc,
    //             this.dataList_Payment[i].bpPackDis,
    //             this.dataList_Payment[i].bpPackPatientID,
    //             this.dataList_Payment[i].specialPaymentType

    //           ));

    //         } else {
    //           this.printReceipt_paymentClass.push(new BillPay_PaymentMethod_Class(
    //             this.dataList_Payment[i].bpPaymentMethodID,
    //             this.dataList_Payment[i].bpPaymentMethodName,
    //             this.dataList_Payment[i].bpArAmount,
    //             this.dataList_Payment[i].bpItemType,
    //             this.dataList_Payment[i].bpPackDesc,
    //             this.dataList_Payment[i].bpPackDis,
    //             this.dataList_Payment[i].bpPackPatientID,
    //             this.dataList_Payment[i].specialPaymentType

    //           ));

    //         }



    //         break;


    //         //  this.log.i(this.TAG,"add payment ID :"+this.dataList_Payment[i].bpPaymentMethodID+" ,new paymentAmount = "+this.dataList_Payment[i].bpArAmount);

    //       }

    //     }

    //   }

    // }



    // loop paymentlist
    let totalPaidAmount = 0;
    this.display_paymentPriceList = '';
    for (let pp = 0; pp < this.printReceipt_paymentClass.length; pp++) {
      // this.log.i(this.TAG, 'dprintReceipt_paymentClass[pp].paymentDesc = ' + this.printReceipt_paymentClass[pp].paymentDesc);
      // this.log.i(this.TAG, 'dprintReceipt_paymentClass[pp].bpItemType = ' + this.printReceipt_paymentClass[pp].bpItemType);
      // this.log.i(this.TAG, 'dprintReceipt_paymentClass[pp].paymentID = ' + this.printReceipt_paymentClass[pp].paymentID);

      // if no equal 0 , (with void)
      if (this.printReceipt_paymentClass[pp].paymentAmount !== 0) {
        if (this.printReceipt_paymentClass[pp].bpItemType === BillPay_ItemType.PAYMENT) {
          if (this.printReceipt_paymentClass[pp].paymentID === 'Package') {

            this.display_paymentList += '其他';

            totalPaidAmount += this.printReceipt_paymentClass[pp].paymentAmount;


            this.display_paymentPriceList += '$' + (-1 * this.printReceipt_paymentClass[pp].paymentAmount).toFixed(1);

          } else {

            this.display_paymentList += this.printReceipt_paymentClass[pp].paymentDesc;
            this.display_paymentPriceList += '$' + (-1 * this.printReceipt_paymentClass[pp].paymentAmount).toFixed(1);
            totalPaidAmount += this.printReceipt_paymentClass[pp].paymentAmount;

            // if(printReceipt_paymentClass[pp].){

            // }
          }

        }


        // totalPaidAmount += printReceipt_paymentClass[pp].paymentAmount;

        if (pp + 1 < this.printReceipt_paymentClass.length) {
          this.display_paymentList += '\n';
          this.display_paymentPriceList += '\n';

        }


      }


    }





    this.display_totalPaidAmount = '$' + (-1 * totalPaidAmount).toFixed(1);


    if (isChangeAccount === true) {
      this.extraRemark = '掛帳';
    } else {
      this.extraRemark = '';
    }


    // ==========end payment display
    this.log.i(this.TAG, 'display_itemNameList = ' + this.display_itemNameList);

  }






  SetupPrintNonFullReciptString() {

    this.log.i(this.TAG, 'do SetupPrintNonFullReciptString');

    this.display_patientName = this.selectedtConsultHeadModelWithPatientInfo.patientChiName;
    this.display_date = this.selectedtConsultHeadModelWithPatientInfo.clthArrivalDateTime;
    this.display_diagonsis = this.selectedtConsultHeadModelWithPatientInfo.clthDiagonsis;

    this.display_itemNameList = '';
    this.display_itemPriceList = '';
    this.display_itemSubtotal = '';

    let itemSubTotal = 0;

    const selectedData: tShoppingCartModelWithItemCateInfo[] = this.selectedModel.selected;

    for (let i = 0; i < selectedData.length; i++) {
      // if bpPrintName not, get auto
      if (selectedData[i].bpPrintName === '' || selectedData[i].bpPrintName == null
        || selectedData[i].bpPrintName === undefined) {
        this.display_itemNameList += selectedData[i].bpItemDesc;
      } else {
        this.display_itemNameList += selectedData[i].bpPrintName;
      }

      // packdis
      // if (this.dataList_Payment[i].bpPaymentMethodID === 'Package' && this.dataList_Payment[i].bpPackDis != null && this.dataList_Payment[i].bpPackDis != undefined) {
      //   printReceipt_paymentClass[p].paymentAmount += (this.dataList_Payment[i].bpArAmount * parseFloat(this.dataList_Payment[i].bpPackDis));

      // var bpPackDis = parseFloat(this.dataList_Item[i].bpPackDis);
      // //   this.log.i(this.TAG,"bpPackDis= "+this.dataList_Item[i].bpPackDis +" , this.dataList_Item[i].bpArAmount *bpPackDis = "+this.dataList_Item[i].bpArAmount *bpPackDis);

      // this.display_itemPriceList += '$' + (this.dataList_Item[i].bpArAmount * bpPackDis).toFixed(1);
      // itemSubTotal += (this.dataList_Item[i].bpArAmount * bpPackDis)
      // }else{
      // }

      if (selectedData[i].bpPackDis != null && selectedData[i].bpPackDis !== undefined) {

        const bpPackDis = parseFloat(selectedData[i].bpPackDis);
        //   this.log.i(this.TAG,"bpPackDis= "+this.dataList_Item[i].bpPackDis +" , this.dataList_Item[i].bpArAmount *bpPackDis = "+this.dataList_Item[i].bpArAmount *bpPackDis);

        this.display_itemPriceList += '$' + (selectedData[i].bpArAmount * bpPackDis).toFixed(1);
        itemSubTotal += (selectedData[i].bpArAmount * bpPackDis);

      } else {
        this.display_itemPriceList += '$' + (selectedData[i].bpArAmount).toFixed(1);
        itemSubTotal += (selectedData[i].bpArAmount);

      }


      // add next line
      if (i + 1 < selectedData.length) {
        this.display_itemNameList += '\n';
        this.display_itemPriceList += '\n';
      }

      //    itemSubTotal += selectedData[i].bpArAmount;
    }
    this.display_itemSubtotal = '$' + itemSubTotal.toFixed(1);
    // this.display_itemSubtotal = "$" + itemSubTotal.toString();




    // -----------------payment display

    this.display_paymentList = '';
    this.display_totalPaidAmount = '';

    const printReceipt_paymentClass: Array<BillPay_PaymentMethod_Class> = [];

    if (this.dataList_Payment.length > 0) {
      printReceipt_paymentClass.push(new BillPay_PaymentMethod_Class(
        this.dataList_Payment[0].bpPaymentMethodID,
        this.dataList_Payment[0].bpPaymentMethodName,
        (itemSubTotal * -1),
        this.dataList_Payment[0].bpItemType,
        this.dataList_Payment[0].bpPackDesc,
        this.dataList_Payment[0].bpPackDis,
        this.dataList_Payment[0].bpPackPatientID,
        this.dataList_Payment[0].specialPaymentType
      ));
    }
    this.log.i(this.TAG, 'printReceipt_paymentClass = ' + printReceipt_paymentClass.length);


    // loop paymentlist
    let totalPaidAmount = 0;
    this.display_paymentPriceList = '';
    for (let pp = 0; pp < printReceipt_paymentClass.length; pp++) {
      this.log.i(this.TAG, 'dprintReceipt_paymentClass[pp].paymentDesc = ' + printReceipt_paymentClass[pp].paymentDesc);

      // if no equal 0 , (with void)
      if (printReceipt_paymentClass[pp].paymentAmount !== 0) {

        if (printReceipt_paymentClass[pp].bpItemType === BillPay_ItemType.PAYMENT) {

          if (printReceipt_paymentClass[pp].paymentID === 'Package') {
            this.display_paymentList += '其他';

          } else {
            this.display_paymentList += printReceipt_paymentClass[pp].paymentDesc;

          }

          this.display_paymentPriceList += '$' + (-1 * printReceipt_paymentClass[pp].paymentAmount).toFixed(1);
          totalPaidAmount += printReceipt_paymentClass[pp].paymentAmount;

          if (pp + 1 < printReceipt_paymentClass.length) {
            this.display_paymentList += '\n';
            this.display_paymentPriceList += '\n';
          }
        }


      }


    }

    this.display_totalPaidAmount = '$' + (-1 * totalPaidAmount).toFixed(1);

    // ==========end payment display

    this.log.i(this.TAG, 'display_itemNameList = ' + this.display_itemNameList);

  }


  setDefaultLanguageString(language: String) {
    
  }

  cancel() {
    // this.log.i(this.TAG, "do cancel");
    this.activeModal.close('Close click');
  }

  formatDate(date: Date) {
    const newDate = new Date(date);

    return this.datepipe.transform(newDate, 'yyyy-MM-dd');
    // return this.dateTimeConvertService.ConvertCurrentDay(newDate);
  }


}
